export default __webpack_public_path__ + "static/media/Video.edea67ae.svg";